<template>
<div class="hello">

    <div class="login">
        <div class="wrap ">
          <div class="txt-center col-white pt-50">
            <span class="font-20">CARROT</span>
            <br>
            <span class="font-30 bold">My Class</span>
            <br><br>
            <p>
              My Class에 오신걸 환영합니다!
            </p>
          </div>

            <div class="box mt-40">
              <p class="txt-center mt-05 font-16 " v-if="is_lock=='true'">
                로그인 연속 5회 실패 하여 계정이 잠겼습니다.
              </p>
              <p class="txt-center mt-05 font-16 " v-if="is_fail && is_lock!='true'">
                로그인 {{cnt_pwd}}회 실패 하였습니다.
                <br>로그인 연속 5회 실패 시 로그인이 차단됩니다.
              </p>
                <label for="">
                    <input type="text" placeholder="ID(E-mail)를 입력해 주세요." class="w-100per mb-20" v-model="info.email">
                </label>
                <label for="">
                    <input type="password" placeholder="비밀번호를 입력해 주세요" class="w-100per" v-model="info.pw">
                </label>
                <p class="col-red mt-05" v-if="is_err">E-mail 혹은 비밀번호를 다시 입력해 주세요.</p>
                <label for="chk01" class="mt-05">
                    <input type="checkbox" id="chk01" name="chk01" @change="saveIdpw()" v-model="is_save">
                    <span></span> ID/PW 기억하기
                </label>
                <span class="btn-login w-100per mt-20" @click="doSubmit()">LOG IN</span>
                <div class="mt-20 txt-center">
                    <span v-if="is_lock=='true'" style="cursor: pointer;" class="col-point" @click="showUnLockpop()" data-toggle="modal" data-target="#unlockModal">비밀번호를 잊으셨나요?</span>
                    <span v-if="is_lock!='true'" style="cursor: pointer;" class="col-point" @click="showPwpop()" data-toggle="modal" data-target="#passwordModal">비밀번호를 잊으셨나요?</span>
                </div>
            </div>
        </div>
    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
    <PwPopupModal :visible="pwVisible" @close="vue_close"></PwPopupModal>

    <UnLockPopupModal :visible="unLockVisible" @close="vue_close"></UnLockPopupModal>
</div>
</template>

<script>
import PwPopupModal from '../components/pop_findPw.vue'
import UnLockPopupModal from '../components/pop_unLockAccount.vue'
export default {
    name: 'Login',
    components: {
        PwPopupModal,
      UnLockPopupModal

    },
    data: () => ({
        pwVisible: false,
        unLockVisible:false,
        info: {
            email: "",
            pw: ""
        },
        is_err: false,
        is_save: false,
        is_fail:false,
        is_lock:false,
        cnt_pwd:0,
        msg: ""
    }),
    mounted() {
        //    this.doc_del_rendar();
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.is_save = false;
        if (localStorage.getItem("email") != null || localStorage.getItem("email") != "") {
            this.info.email = localStorage.getItem("email");
            this.info.pw = localStorage.getItem("pw");
            if(this.info.email == 'null'){
                this.info.email = '';
            }
            if(this.info.pw == 'null'){
                this.info.pw = '';
            }
            if(localStorage.getItem("is_save") == "1"){
                this.is_save = true;
            }else{
                this.is_save = false;
            }
        } else {
            this.info.email = "";
            this.info.pw = "";
            this.is_save = false;
            if(localStorage.getItem("is_save") == "1"){
                this.is_save = true;
            }else{
                this.is_save = false;
            }
        }
    },
    methods: {
        saveIdpw:function() {
            if (this.is_save == true) {
                localStorage.setItem("email", this.info.email);
                localStorage.setItem("pw", this.info.pw);
                localStorage.setItem("is_save", "1");
            } else {
                localStorage.setItem("email", "");
                localStorage.setItem("pw", "");
                localStorage.setItem("is_save", "0");
            }
        },
        showPwpop:function() {
            this.pwVisible = true;
        },
        showUnLockpop:function() {
          this.unLockVisible = true;
        },


        vue_close:function(state) {
            this.pwVisible = state;
           this.unLockVisible = state;
        },
        doSubmit:function() {

          this.is_fail = false;
          this.is_lock=false;

            var me = this;
            if (me.info.email == "") {
                this.is_err = true;
                return false;
            } else {
                this.is_err = false;
            }
            if (me.info.pw == "") {
                this.is_err = true;
                return false;
            } else {
                this.is_err = false;
            }

            if (this.is_save == true) {
                localStorage.setItem("email", this.info.email);
                localStorage.setItem("pw", this.info.pw);
                localStorage.setItem("is_save", "1");
            } else {
                localStorage.setItem("email", "");
                localStorage.setItem("pw", "");
                localStorage.setItem("is_save", "0");
            }

            var email = this.info.email;
            var password = this.info.pw;

            this.$store.dispatch('LOGIN', {
                    email,
                    password
                })
                .then(() => this.redirect())
                .catch(({
                    message
                }) => this.data = message)
            console.log(this.data);
        },
        redirect:function() {
          this.is_fail = true;
          this.cnt_pwd=localStorage.getItem("fail_cnt");
          this.is_lock=localStorage.getItem("is_lock");
          console.log(localStorage.getItem("accessToken"));
          console.log(localStorage.getItem("accessKey"));
          //console.log(this.is_fail);
          //console.log(this.is_lock);
          //console.log(this.cnt_pwd);

          if(this.is_lock=='true'){
            this.unLockVisible = true;
          }
            // this.$router.push("/intro")
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.wrap {
    width: 90%;
    max-width: 700px;
    margin: 0 auto;
}

//
.login {
    background: url("../assets/img/login-bg.png") no-repeat center -250px;

    .wrap {
        max-width: 500px;
    }

    h1 {
        padding-top: 40px;

        span {

            font-size: 18px;
            color: #ffffffb3;
            display: block;
        }
    }

    .box {
        border-radius: 20px;
        padding: 20px;
        background: #ffffff;
        border-radius: 20px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

        p {
            font-size: 14px;
        }

        label {
            width: 100%;
            font-size: 14px;
            color: #585858;
        }
    }
}

@media only screen and (max-width: 414px) {
    .box {
        border-radius: 0px;
        box-shadow: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
    }
}

input[type="text"],
input[type="password"] {
    border-radius: 0;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid #E9E9E9;
    font-size: 16px;
    height: 45px;
    padding: 0 10px;
}

input[type="checkbox"] {
    display: none;
}

input[type="checkbox"]+span {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: none;
    border: 1px solid $point-color;
    cursor: pointer;
    vertical-align: middle;
}

input[type="checkbox"]:checked+span {
    width: 15px;
    height: 15px;
    background: $point-color url("../assets/img/checkbox.png") no-repeat center;
    background-size: 12px;
}

.btn-login {
    display: inline-block;
    background: $point-color;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    border-radius: 10px;
    padding: 10px 0;
    cursor: pointer;
}
</style>
